export const createCustomerMutation = `
    mutation createCustomer($input: CreateCustomerInput!) {
        createCustomer(input: $input) {
            id
            name
            status
            contactInfo {
                email
                phone
                website
            }
        }
    }
`;

export const updateCustomerMutation = `
    mutation updateCustomer($input: UpdateCustomerInput!) {
        updateCustomer(input: $input) {
            id
            name
            status
            contactInfo {
                email
                phone
                website
            }
        }
    }
`;
